import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { SigninService } from 'src/app/auth/signin/signin.service';
import { StateStorageService } from '../auth/state-storage.service';
import { Router } from '@angular/router';

@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(
    private loginService: SigninService,
    private stateStorageService: StateStorageService,
    private router: Router
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (
            (err.status === 401 || err.status === 0) &&
            err.url &&
            !err.url.includes('api/account')
          ) {
            this.stateStorageService.storeUrl(
              this.router.routerState.snapshot.url
            );
            this.loginService.logout();
            this.router.navigate(['/login']);
          }
        },
      })
    );
  }
}
